import { render, staticRenderFns } from "./slideshowBox.vue?vue&type=template&id=65ed8e1e&"
import script from "./slideshowBox.vue?vue&type=script&lang=js&"
export * from "./slideshowBox.vue?vue&type=script&lang=js&"
import style0 from "./slideshowBox.vue?vue&type=style&index=0&id=65ed8e1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports